'use strict';
namespace TR {

    import BasketCrossSellService = Core.BasketCrossSellService;
    import TripService = Core.TripService;
    import IScope = angular.IScope;
    import Hotel = Core.ManageBooking.Hotel;
    import HotelDetails = Core.Hotels.HotelDetails;
    interface RouteParams extends ng.route.IRouteService {
        tripId: string;
        productId: string;
    }

    interface Airport {
        Code: string;
        Title: string;
    }


    class HotelOptionsSearchUnit {

        airports: Airport[];
        arrivalDate: Date;
        minFlightArrivalDate: Date;
        minFlightDepartureDate: Date;
        isArrivalTimeApproved: boolean = false;
        departureDate: Date;
        isDepartureTimeApproved: boolean = false;
        selectedAirport: Airport;


        constructor(
            private basketStore,
            private tripService: TripService,
            private $routeParams: RouteParams,
            private $scope: IScope,
            private resourceService: Core.ResourceService,
            private broker: Core.Broker,
            private $q: ng.IQService,
            private dateUtil: any,
            private analytics: any
        ) {

            tripService.getTrip($routeParams.tripId).then((trip: Core.Trip.TripState) => {
                if (!trip) { return; }

                $q.all({
                    hotel: basketStore.hotel(trip.BasketId, $routeParams.productId),
                    checkInDate: tripService.getHotelsRequestCheckInDate(trip.TripId, true),
                    checkOutDate: tripService.getHotelsRequestCheckOutDate(trip.TripId, true)
                }).then(({hotel, checkInDate, checkOutDate} :
                    {hotel : HotelDetails, checkInDate: Date, checkOutDate: Date}) => {

                    const transferArrivalDate: Date = _.get<Date>(trip, 'TransfersRequest.ArrivalDate');
                    const transferDepartureDate: Date = _.get<Date>(trip, 'TransfersRequest.ReturnDate');

                    this.arrivalDate = checkInDate || transferArrivalDate;
                    this.departureDate = checkOutDate || transferDepartureDate;

                    this.minFlightArrivalDate = this.arrivalDate;
                    this.minFlightDepartureDate = this.dateUtil.addDays(this.arrivalDate, 1);

                    this.isArrivalTimeApproved = !!transferArrivalDate;
                    this.isDepartureTimeApproved = !!transferDepartureDate;

                    this.airports = <Airport[]>_.get(hotel, 'Details.LinkedAirports', []);
                    this.selectedAirport =
                        _.find<Airport>(this.airports, a => a.Code === _.get(trip, 'TransfersRequest.AirportCode'))
                        || this.airports[0];
                    // if (this.selectedAirport) {
                    //     this.broker.publish('flightDataUpdated', {
                    //         airport: this.selectedAirport
                    //     });
                    // }
                });
            });

            this.$scope.$watch('$ctrl.arrivalDate', () => {
                this.validateDates('arrival');
            });

            this.$scope.$watch('$ctrl.departureDate', () => {
                this.validateDates('departure');
            });
        }

        validateDates(type) {
            if(this.dateUtil.compareDates(this.arrivalDate, this.departureDate) >= 0) {
                switch(type){
                    case 'arrival':
                        this.departureDate = this.dateUtil.addDays(this.arrivalDate, 1);
                        break;
                    case 'departure':
                        this.arrivalDate = this.dateUtil.addDays(this.departureDate, -1);
                        break;
                }
            }
        }

        setArrivalDate(date): void { this.arrivalDate = date; }

        setDepartureDate(date): void { this.departureDate = date; }

        search(): void {
            const errors = _([this.isArrivalTimeApproved, this.isDepartureTimeApproved]).zip(
                ['SELECTARRIVALDATETIME', 'SELECTRETURNDATETIME'])
                .filter(z => !z[0])
                .map(z => this.resourceService.get(z[1]))
                .value();

            if(errors.length){
                this.analytics.track('mixpanel', 'OptionsTransferSearch', {
                    ValidationFail: errors
                });
            }
            this.$scope.$emit(errors.length ? 'flash:error' : 'flash:hide', errors);

            this.analytics.track('mixpanel', 'OptionsTransferSearch', {
                Airport: this.selectedAirport.Title
            });

            this.isArrivalTimeApproved &&
                this.isDepartureTimeApproved &&
                this.broker.publish('flightDataUpdated', {
                    airport: this.selectedAirport,
                    dates: {
                        arrivalDate: this.arrivalDate,
                        departureDate: this.departureDate
                    }
                });
        }
    }

    angular
        .module('TR')
        .component('hotelOptionsSearchUnit', {
            controller: HotelOptionsSearchUnit,
            templateUrl: 'partials/home/directivetemplate?type=hotelOptionsSearchUnit'
        });
}
